// components/common/filters/FilterColorSection.tsx
import { Check } from "lucide-react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/app/components/shadcn/accordion";
import {
  FilterListGroup,
  FilterColorListItem,
  isLightColor,
} from "@/app/lib/features/filters/filters.types";
import useFilters from "@/app/lib/features/filters/filters.hook";

// Not: "en az bir filtre seçili kalmalı" kuralı BURADA YOK ve bu bilinçli.
// Kural yalnızca kategori/ürün grubu/alt kategori üçlüsü için var (bkz.
// MINIMUM_GUARDED_KEYS); renk bir daraltma filtresi, hepsi kaldırılınca liste
// yalnızca genişliyor. Eskiden tüm filtreler sayıldığı için son kalan tek renk
// de kaldırılamıyordu. disableMinimumFilter prop'u çağıranların imzası bozulmasın
// diye duruyor, artık bir şey yapmıyor.
interface FilterColorSectionProps {
  filter: FilterListGroup;
  disableMinimumFilter?: boolean;
}

const FilterColorSection = ({ filter }: FilterColorSectionProps) => {
  const { toggleList, selected } = useFilters();
  const items = filter.items as FilterColorListItem[];
  const selectedColors = selected.color;

  if (items.length === 0) return null;

  return (
    <AccordionItem value={filter.key}>
      <AccordionTrigger className="hover:bg-muted p-2 my-2">
        {filter.title}
        {selectedColors.length > 0 && (
          <span className="ml-auto mr-2 w-5 h-5 flex items-center justify-center text-xs bg-black text-white rounded-full shrink-0">
            {selectedColors.length}
          </span>
        )}
      </AccordionTrigger>
      <AccordionContent className="p-1">
        <div className="max-h-75 overflow-y-auto">
          <div className="grid grid-cols-3 gap-3 px-1 py-1.5">
            {items.map((item, idx) => {
              const sel = selectedColors.includes(String(item.id));
              const hex = item.hex.trim();

              return (
                <div
                  key={`${item.id}-${idx}`}
                  className="flex flex-col items-center gap-2"
                >
                  <button
                    type="button"
                    onClick={() => toggleList("color", item.id)}
                    className="relative w-6 h-6 rounded-full cursor-pointer flex items-center justify-center transition-all ring-1 ring-gray-300"
                    style={{
                      backgroundColor: hex,
                      outline: sel ? "2px solid #111827" : "none",
                      outlineOffset: "2px",
                      transform: sel ? "scale(1.1)" : "scale(1)",
                    }}
                  >
                    {sel && (
                      <Check
                        size={12}
                        className="drop-shadow"
                        style={{
                          color: isLightColor(hex) ? "#111827" : "#ffffff",
                        }}
                      />
                    )}
                  </button>
                  <span className="text-[11px] text-muted-foreground text-center leading-tight">
                    {item.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default FilterColorSection;
